'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _class, _temp;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _next = require('@alifd/next');

var _vuFusionField = require('../common/vu-fusion-field');

var _vuFusionField2 = _interopRequireDefault(_vuFusionField);

require('./view.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var translate = function translate(string, codeMap, type) {
  var result = true;
  var new_string = [];
  for (var i = 0; i < string.length; i++) {
    var char = string[i];
    if (!codeMap[char] || !codeMap[char][type]) {
      result = false;
      new_string.push(char);
    } else {
      new_string.push(codeMap[char][type]);
    }
  }

  return [result, new_string.join('')];
};

var mapCode = function mapCode(symbol) {
  if (!symbol) return {};
  return Object.keys(symbol).reduce(function (acc, current) {
    var _extends2;

    return _extends({}, acc, (_extends2 = {}, _defineProperty(_extends2, symbol[current].sup, {
      sup: symbol[current].sup,
      sub: symbol[current].sub
    }), _defineProperty(_extends2, symbol[current].sub, {
      sup: symbol[current].sup,
      sub: symbol[current].sub
    }), _extends2));
  }, symbol);
};

var SymbolInputField = (_temp = _class = function (_Field) {
  _inherits(SymbolInputField, _Field);

  function SymbolInputField(props) {
    _classCallCheck(this, SymbolInputField);

    var _this = _possibleConstructorReturn(this, _Field.call(this, props));

    _this.onSelect = function (event) {
      var _ref = event.target || {},
          value = _ref.value,
          selectionStart = _ref.selectionStart,
          selectionEnd = _ref.selectionEnd;

      var selection = value.substring(selectionStart, selectionEnd);
      _this.setState({
        selection: selection,
        selectionStart: selectionStart,
        selectionEnd: selectionEnd
      });
    };

    _this.onBlur = function () {
      var focus = _this.focus;
      setTimeout(function () {
        if (focus !== _this.focus) {
          return;
        }
        _this.setState({
          selection: '',
          selectionStart: 0,
          selectionEnd: 0,
          visible: false
        });
      }, 200);
    };

    _this.focus = 0;

    _this.onFocus = function () {
      _this.focus = _this.focus + 1;
      _this.setState({
        visible: true
      });
    };

    _this.onClick = function () {
      _this.setState({
        selection: '',
        selectionStart: 0,
        selectionEnd: 0
      });
    };

    _this.transform = function (type) {
      var _this$getControlProps = _this.getControlProps(),
          _this$getControlProps2 = _this$getControlProps.value,
          value = _this$getControlProps2 === undefined ? '' : _this$getControlProps2;

      var _this$state = _this.state,
          selection = _this$state.selection,
          selectionStart = _this$state.selectionStart,
          selectionEnd = _this$state.selectionEnd,
          codeMap = _this$state.codeMap;

      var translateValue = translate(selection, codeMap, type);
      var newValue = value.substring(0, selectionStart) + translateValue[1] + value.substring(selectionEnd);
      if (!translateValue[0]) {
        _this.setState({
          failed: true
        }, function () {
          setTimeout(function () {
            _this.setState({
              failed: false
            });
          }, 2000);
        });
      }

      if (translateValue[1]) {
        _this.getControlProps().onChange(newValue);
        Promise.resolve(0).then(function () {
          var input = _this.textInput.current.getInputNode();
          input.focus();
          input.setSelectionRange(selectionStart, selectionEnd);
        });
      } else {
        Promise.resolve(0).then(function () {
          var input = _this.textInput.current.getInputNode();
          input.focus();
        });
      }
    };

    var symbol = props.symbol || {
      2: {
        sup: '²',
        sub: '₂'
      },
      3: {
        sup: '₃'
      }
    };

    _this.textInput = _react2.default.createRef(null);
    _this.state = {
      selection: '',
      selectionStart: 0,
      selectionEnd: 0,
      codeMap: mapCode(symbol),
      failed: false,
      visible: false
    };
    return _this;
  }

  SymbolInputField.prototype.getProps = function getProps() {
    return _extends({}, this.props, {
      fieldClassName: 'vc-input',
      htmlType: 'text'
    });
  };

  SymbolInputField.prototype.componentDidMount = function componentDidMount() {
    _Field.prototype.componentDidMount.call(this);
    if (!this.textInput.current) return;
    var input = this.textInput.current.getInputNode();

    input.addEventListener('select', this.onSelect);
    input.addEventListener('blur', this.onBlur);
    input.addEventListener('focus', this.onFocus);
    input.addEventListener('click', this.onClick);
  };

  SymbolInputField.prototype.componentWillUnmount = function componentWillUnmount() {
    typeof _Field.prototype.componentDidMount === 'function' && _Field.prototype.componentDidMount.call(this);
    if (!this.textInput.current) return;
    var input = this.textInput.current.getInputNode();

    input.removeEventListener('select', this.onSelect);
    input.removeEventListener('blur', this.onBlur);
    input.removeEventListener('focus', this.onFocus);
    input.removeEventListener('click', this.onClick);
  };

  SymbolInputField.prototype.renderControl = function renderControl() {
    var _this2 = this;

    var commonProps = this.getControlProps();

    var inputProps = _extends({}, commonProps, {
      style: _extends({}, commonProps.styles || {}, { width: '100%' })
    });

    return _react2.default.createElement(
      'div',
      { style: { width: '100%' } },
      _react2.default.createElement(
        _next.Balloon,
        {
          offset: [-15, 25],
          visible: this.state.visible,
          closable: false,
          align: 'tl',
          alignEdge: true,
          trigger: _react2.default.createElement(_next.Input, _extends({}, inputProps, { ref: this.textInput })),
          popupClassName: 'symbol-popup',
          triggerType: 'focus'
        },
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'span',
            {
              className: 'symbol-popup-text ' + (this.state.selection ? '' : 'symbol-popup-text-disabled'),
              onClick: function onClick() {
                if (_this2.state.selection) {
                  _this2.transform('sup');
                } else {
                  Promise.resolve(0).then(function () {
                    var input = _this2.textInput.current.getInputNode();
                    input.focus();
                  });
                }
              },
              title: !this.state.selection ? '请先选中需要切换的字符' : ''
            },
            'x\xB2'
          ),
          _react2.default.createElement(
            'span',
            {
              className: 'symbol-popup-text ' + (this.state.selection ? '' : 'symbol-popup-text-disabled'),
              onClick: function onClick() {
                if (_this2.state.selection) {
                  _this2.transform('sub');
                } else {
                  Promise.resolve(0).then(function () {
                    var input = _this2.textInput.current.getInputNode();
                    input.focus();
                  });
                }
              },
              title: !this.state.selection ? '请先选中需要切换的字符' : ''
            },
            'x\u2082'
          )
        )
      ),
      _react2.default.createElement(
        _next.Balloon,
        {
          offset: [0, 25],
          visible: this.state.failed,
          closable: false,
          align: 'tl',
          alignEdge: true,
          trigger: _react2.default.createElement('div', null),
          popupClassName: 'symbol-popup'
        },
        _react2.default.createElement(
          'div',
          { className: 'symbol-popup2-text' },
          _react2.default.createElement(_next.Icon, { type: 'error', size: 'xs', style: { marginRight: '4px' } }),
          '\u8BE5\u5B57\u7B26\u65E0\u6CD5\u5207\u6362\u4E3A\u89D2\u6807'
        )
      )
    );
  };

  return SymbolInputField;
}(_vuFusionField2.default), _class.displayName = 'SymbolInput', _class.defaultProps = _extends({}, _vuFusionField2.default.defaultProps, {
  fieldId: null,
  label: null
}), _class.propTypes = {
  fieldId: _propTypes2.default.string,
  label: _propTypes2.default.string
}, _temp);
exports.default = SymbolInputField;
module.exports = exports['default'];